import React from 'react';
import { Link } from 'react-router-dom';
import { BUILD_STAMP } from '../../buildStamp';
import {
    shopDemoWalkCurrentStep,
    shopDemoWalkEyebrow,
    shopDemoWalkKeepNote,
    shopDemoWalkNote,
    shopDemoWalkSotLinks,
    shopDemoWalkStampHint,
    shopDemoWalkStampLine,
    shopDemoWalkStepClass,
    shopDemoWalkSteps,
} from './demoWalk';
import { shopJobsSotExitHref } from './jobsSurface';

const DemoWalk = ({ search, sot, preview, createSot, createPreview, pendingCount, completeCount, openTab, jobStatus, regionLabel }) => {
    const current = shopDemoWalkCurrentStep({
        search,
        sot,
        preview,
        createSot,
        createPreview,
        pendingCount,
        completeCount,
        openTab,
        jobStatus,
    });
    return (
        <aside className="shop-demo-walk" data-testid="shop-demo-walk" aria-label={shopDemoWalkNote()}>
            <p className="shop-demo-walk-eyebrow">{shopDemoWalkEyebrow(regionLabel || 'glass-shop')}</p>
            <ol>
                {shopDemoWalkSteps(search).map((step) => (
                    <li
                        key={step.id}
                        className={shopDemoWalkStepClass(step.id, current)}
                        aria-current={step.id === current ? 'step' : undefined}
                    >
                        <span className="shop-demo-walk-n">{step.n}</span>
                        <span>
                            {step.href ? <Link to={step.href}>{step.label}</Link> : step.label}
                            {step.detail ? ` ${step.detail}` : null}
                        </span>
                    </li>
                ))}
            </ol>
            <p className="shop-demo-walk-keep">{shopDemoWalkKeepNote()}</p>
            <p className="shop-demo-walk-sot">
                SoT helpers:{' '}
                {shopDemoWalkSotLinks(search).map((link, index) => (
                    <React.Fragment key={link.id}>
                        {index > 0 ? ' · ' : null}
                        <Link to={link.href}>{link.label}</Link>
                    </React.Fragment>
                ))}
                {' · '}
                <Link to={shopJobsSotExitHref(search)}>Exit SoT</Link>
            </p>
            <p className="shop-demo-walk-stamp">
                <span className="shop-demo-walk-stamp-id">{shopDemoWalkStampLine(BUILD_STAMP)}</span>
                <span className="shop-demo-walk-stamp-hint">{shopDemoWalkStampHint()}</span>
            </p>
        </aside>
    );
};

export default DemoWalk;
